export default function getResource(label, vars = []) {
    const resources = {
        close: 'Fermer',
        shopNow: 'Magasinez maintenant, payez plus tard',
        interestFree: 'Payez en quatre versements de',
        interestFreeDescription: 'Payez en quatre versements pour répartir le coût et sans frais supplémentaires lorsque vous payez à temps.',
        addItems: 'Ajoutez les articles à votre panier',
        chooseAfterpayOrKlarna: 'Allez à la caisse de sortie et choisissez Klarna ou Afterpay',
        chooseAfterpay: 'Allez à la caisse de sortie et choisissez Afterpay',
        chooseKlarna: 'Allez à la caisse de sortie et choisissez Klarna',
        enterCardInfo: 'Entrez les renseignements de votre carte de débit ou de crédit',
        payLater: 'Payez plus tard en quatre versements. Le premier paiement est effectué lorsque la commande est traitée et les trois autres le sont automatiquement à des intervalles planifiés',
        learnMore: 'En savoir plus',
        gotIt: 'Compris'
    };

    return resources[label];
}
